import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Page } from '@dixa/lib-shared-habla';
import { Phone } from 'components/settings/components/sections/telephony/phone';
export const SettingsPhoneView = () => {
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: "Phone" }), _jsx(Page.Body, { children: _jsx(Phone, {}) })] }));
};
